import { makeStyles } from "@mui/styles"
import Colors from "utils/Colors"

const styles = makeStyles(() => ({
  root: {
    backgroundColor: Colors.lightGray,
    border: `1px solid ${Colors.gray}`,
    borderRadius: '5px',
    padding: '1rem',
  },
}))

export default styles
